import React, { useState, useEffect } from 'react';
import { Input, Checkbox, Button, Icon, Menu, Dropdown } from '@tinper/next-ui'
import { reaction } from 'mobx'
import { observer } from 'mobx-react'

import _ from 'lodash';
import { getFieldId } from '../../utils/tools';
import './index.less';
const { Item } = Menu

const onSearch = async (referRootStore: any) => { // 搜索
  await referRootStore.referInputProps.onSearchTableRef?.(referRootStore.referStore.getValue('requestData.likeValue'))
  // referRootStore.referStore.setValue('requestData.likeValue', searchValue)
  referRootStore.searchData({ type: 'search' })
}

const ReferSearch = observer((props: any) => {
  const { referRootStore } = props
  if (!referRootStore.filterStore?.searchVisible) return null
  return (
    <>{ referRootStore.refEntity.cTpltype === 'Tree' ? <TreeSearch {...props}/> : <TableSearch {...props}/> }</>
  );
})

export default React.memo(ReferSearch)

// 单选时展示层级面包屑
const getShowValue = (referRootStore:any, selectedKey: any, textField: any) => {
  try {
    const keyMap = referRootStore.treeStore.keyMap
    return keyMap[selectedKey].realPath.map((e: any) => keyMap[e][textField]).join('/')
  } catch {
    return ''
  }
}

const getExpandKeys = (obj: any, level: any) => {
  const res = []
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const ele = obj[key];
      if (level === 'all') {
        ele.realPath.length >= 2 && res.push(ele.parent)
      } else {
        ele.realPath.length > 1 && ele.realPath.length <= level + 1 && res.push(ele.parent)
      }
    }
  }
  return res
}

const TreeSearch = observer((props: any) => {
  const { inputProps, referRootStore } = props
  const [valuePath, setValuePath] = useState();
  const [checkType, setCheckType] = useState(false);
  const [level, setLevel] = useState(0)

  const btnText = lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0003C', '全部选择', undefined, { returnDom: true, placement: 'top' }) // 按钮文字
  const btnTextCancle = lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0003B', '全部取消', undefined, { returnDom: true, placement: 'top' })
  const showStopStatus = referRootStore.refEntity.extendFieldJson.isShowDisabled

  useEffect(() => {
    const valueChange = reaction(() => referRootStore.treeStore.selectedKeys, (val: any) => {
      const text = getShowValue(referRootStore, val[0], inputProps.textField)
      setValuePath(text)
    })
    if (referRootStore.treeStore.selectedKeys) {
      setValuePath(getShowValue(referRootStore, referRootStore.treeStore.selectedKeys[0], inputProps.textField))
    }

    const dataSourceChange = reaction(() => referRootStore.treeStore.maxLevel, (val: any) => {
      val === 0 ? setLevel(0) : setLevel(val - 1)
    })
    return () => {
      valueChange()
      dataSourceChange()
    }
  }, [])

  const selectAll = () => { // 全选
    const keys = []
    if (!checkType) {
      const keymap = referRootStore.treeStore.keyMap
      for (const key in keymap) {
        if (Object.prototype.hasOwnProperty.call(keymap, key)) {
          const element = keymap[key];
          if (element) { // element -- 判断节点是否可以选
            keys.push(key)
          }
        }
      }
    }
    setCheckType(!checkType)
    referRootStore.treeStore.onExCheck(keys)
  }

  const checkShowStop = (e: any) => { // 显示停用
    // setStopStatus(e.target.checked)
    referRootStore.referStore.setValue('stopShow', e.target.checked)
  }

  const onSelectMenu = (val: any) => { // 展开层级
    let expandedKeys: any = []
    if (val.key === '1') {
      expandedKeys = getExpandKeys(referRootStore.treeStore.currMap, 'all')
    } else if (val.key === '2') {
      expandedKeys = []
    } else if (val.key * 1 > 2) {
      expandedKeys = getExpandKeys(referRootStore.treeStore.currMap, val.key - 2)
    }
    referRootStore.treeStore.expandedKeys = expandedKeys
  }

  const menu = (<Menu onSelect={onSelectMenu} fieldid={`${getFieldId(inputProps)}`}>
    <Item key='1'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0003D', '全部展开', undefined, { returnDom: true, placement: 'top' })}</Item>
    <Item key='2'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0003F', '全部收起', undefined, { returnDom: true, placement: 'top' })}</Item>
    {
      Array(level).fill('').map((item, index) => <Item key={index + 3}>
        {`${lang.templateByUuid('UID:P_FW_174E6C8C052804DE', '展开')}${index + 1}${lang.templateByUuid('UID:P_FW_174E6C8C052804DD', '级')}`}
      </Item>)
    }
  </Menu>);

  return <>
    {
      !inputProps.dropdown && referRootStore.refEntity.cTpltype === 'Tree' && !inputProps.dataMultiple
        ? <div className='tree-single-text'>
          {valuePath || <span className='unselect'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00043', '未选择', undefined, { returnDom: true, placement: 'top' })}</span>}
        </div>
        : null
    }

    {
      !inputProps.dropdown && <div className='refer-search-box'>
        <Input
          value={referRootStore.referStore.getValue('requestData.likeValue')}
          onSearch={() => onSearch(referRootStore)}
          type='search'
          onChange={(val: any) => referRootStore.referStore.setValue('requestData.likeValue', val) }
          className='refer-search-input'
          placeholder={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00035', '请输入关键词', undefined, { returnDom: true, placement: 'top' })}
          fieldid={`${getFieldId(inputProps)}_table_search`}
        />
        { inputProps.multiple && <Button className='dropdown-btn' onClick={() => selectAll()} fieldid={`${getFieldId(inputProps)}_tree_selectall`}>{checkType ? btnTextCancle : btnText}</Button> }
        {
          !referRootStore.topName && !inputProps.hiddenCtrlDropdown &&
            <Dropdown overlay={menu} className='dropdown-btn' getPopupContainer={() => document.getElementsByClassName('refer-search-box')[0]} fieldid={`${getFieldId(inputProps)}_tree_dpd`}>
              <Button>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00042', '展开', undefined, { returnDom: true, placement: 'top' })}<Icon type='uf-anglearrowdown' fieldid={`${getFieldId(inputProps)}_tree_dpd_btn`} /></Button>
            </Dropdown>
        }
        {
          // 只有查询区才展示'显示停用'按钮--???
          showStopStatus
            ? <Checkbox antd checked={referRootStore.referStore.stopShow} onClick={(e: any) => checkShowStop(e)} className='refer-search-checkbox' fieldid={`${getFieldId(inputProps)}_stopstatus`}>
              {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00038', '显示停用', undefined, { returnDom: true, placement: 'top' })}
            </Checkbox>
            : null
        }
      </div>
    }

  </>
})

const TableSearch = observer((props: any) => {
  const { inputProps, referRootStore } = props
  const { cardBillno } = inputProps
  const showStopStatus = referRootStore.refEntity.extendFieldJson.isShowDisabled

  const onResetSearch = _.throttle(() => { // 重置
    referRootStore.referStore.setValue('exactQuery', false)
    referRootStore.referStore.setValue('stopShow', undefined)

    referRootStore.searchData({ type: 'search', params: { likeValue: '' } })
  }, 1000, { leading: true, trailing: false })

  const checkShowStop = (e: any) => { // 显示停用
    referRootStore.referStore.setValue('stopShow', e.target.checked)
  }

  const onExactQuery = (e: any) => { // 精准搜索
    referRootStore.referStore.setValue('exactQuery', e.target.checked)
  }

  return <div className='refer-search-box'>
    <Input
      value={referRootStore.referStore.getValue('requestData.likeValue')}
      onSearch={() => onSearch(referRootStore)}
      type='search'
      onChange={(val: any) => referRootStore.referStore.setValue('requestData.likeValue', val) }
      className='refer-search-input'
      placeholder={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00035', '请输入关键词', undefined, { returnDom: true, placement: 'top' })}
      fieldid={`${getFieldId(inputProps)}_table_search`}
    />
    <Button bordered icon={<Icon type='uf-chongzhi1' />} onClick={() => onResetSearch()} className='refer-search-backbtn' fieldid={`${getFieldId(inputProps)}_table_search_btn`} />
    <Checkbox antd checked={referRootStore.referStore.exactQuery} onClick={(e: any) => onExactQuery(e)} className='refer-search-checkbox' fieldid={`${getFieldId(inputProps)}_exactquery`}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00036', '精准搜索', undefined, { returnDom: true, placement: 'top' })}</Checkbox>
    {
      // 只有查询区才展示'显示停用'按钮
      showStopStatus
        ? <Checkbox antd checked={referRootStore.referStore.stopShow} onClick={(e: any) => checkShowStop(e)} className='refer-search-checkbox' fieldid={`${getFieldId(inputProps)}_stopstatus`}>
          {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00038', '显示停用', undefined, { returnDom: true, placement: 'top' })}
        </Checkbox>
        : null
    }
    {
      cardBillno && referRootStore.referStore.btnAddVisible ? <><div style={{ flex: 1 }}></div><Button bordered onClick={() => referRootStore.actions.referAdd.doAction()} colors='primary' fieldid={`${getFieldId(inputProps)}_table_data_add`} >{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6CC05D0001E', '新增')}</Button></> : null
    }

  </div>
})
